import React, { Component, PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';

export class Header extends Component {
  static propTypes = {
    info: PropTypes.object.isRequired,
    panelInfo: PropTypes.object.isRequired,
  };

  render() {
    const { info, panelInfo } = this.props;
    return (
      <section id="panel-header" style={{backgroundColor: this.props.panelInfo.header_color}}>
        <div id="avatar" className="hide-mobile-tablet">
          <img src={info.logo190x190} />
        </div>
        <div id="title">
          <span id="panel-title">{panelInfo.title}</span>
          <br/>
          <span id="panel-subtitle">{panelInfo.subtitle}</span>
        </div>
        <div id="generation-time">
          <FormattedMessage id="generated_at" values={{time: info.gen_time}} />
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./components/header/Header.js